import { useSyncExternalStore } from 'react';

let pendingLabel: string | undefined;
let safetyTimer: ReturnType<typeof setTimeout> | undefined;
const listeners = new Set<() => void>();

const PENDING_TIMEOUT_MS = 15_000;

const notify = () => listeners.forEach((listener) => listener());

export const setPendingQuoteLine = (label: string) => {
  pendingLabel = label;
  clearTimeout(safetyTimer);
  safetyTimer = setTimeout(clearPendingQuoteLine, PENDING_TIMEOUT_MS);
  notify();
};

export const clearPendingQuoteLine = () => {
  if (pendingLabel === undefined) return;
  pendingLabel = undefined;
  clearTimeout(safetyTimer);
  notify();
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const usePendingQuoteLine = () => useSyncExternalStore(subscribe, () => pendingLabel);
